(() => {
  let cartTimer;
  const refreshCartCount = () => {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(async () => {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin' });
        if (!response.ok) return;
        const cart = await response.json();
        document.querySelectorAll('.qgc-cart-link').forEach(link => {
          link.setAttribute('aria-label', `Shopping bag, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`);
          const badge = link.querySelector('.qgc-cart-count');
          if (badge) badge.textContent = cart.item_count;
        });
      } catch (_) { /* Native cart remains available when a count refresh fails. */ }
    }, 650);
  };
  document.addEventListener('submit', e => {
    if (e.target.matches('form[action*="/cart"]')) {
      refreshCartCount(); setTimeout(refreshCartCount, 1600);
    }
  }, true);
  document.addEventListener('click', e => {
    if (e.target.closest('a[href*="/cart/change"],.form-cart button,.form-cart .quantity-button')) {
      refreshCartCount(); setTimeout(refreshCartCount, 1600);
    }
  }, true);
  document.addEventListener('change', e => {
    if (e.target.closest('.form-cart')) refreshCartCount();
  });
  // Initial count comes from Liquid; only restore-time navigation needs a fresh request.
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCartCount(); });
})();
